export default __webpack_public_path__ + "static/media/976.be7ce089.png";